// extracted by css-extract-rspack-plugin
export default {"headshot":"_17c37416","image":"_6193e319"};